(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["klaly-compare"] && !Shopify.designMode) return;
  try {
    
  class KlCompare extends HTMLElement {
    connectedCallback() {
      this.chips = [...this.querySelectorAll('.kl-compare__chip')];
      this.chips.forEach((chip) => {
        chip.addEventListener('click', () => this.select(chip.dataset.column));
      });
    }

    select(column) {
      this.dataset.active = column;
      this.chips.forEach((chip) => {
        chip.setAttribute('aria-pressed', String(chip.dataset.column === column));
      });
    }
  }

  if (!customElements.get('kl-compare')) {
    customElements.define('kl-compare', KlCompare);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klaly-results-timeline"] && !Shopify.designMode) return;
  try {
    
  class KlTimeline extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.kl-timeline__track');
      this.fill = this.querySelector('.kl-timeline__track-fill');
      if (!this.track || !this.fill) return;

      this.onResize = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.measure());
      };
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(this);
      } else {
        window.addEventListener('resize', this.onResize);
      }
      this.measure();

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion || !('IntersectionObserver' in window)) {
        this.classList.add('is-visible');
        return;
      }

      this.classList.add('is-ready');
      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.classList.add('is-visible');
          this.observer.disconnect();
        },
        { threshold: 0.4 }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
      this.resizeObserver?.disconnect();
      this.observer?.disconnect();
    }

    /* Place la ligne entre le premier et le dernier repère, et le remplissage jusqu'à l'étape mise en avant. */
    measure() {
      const nodes = [...this.querySelectorAll('.kl-timeline__node')];
      this.track.hidden = nodes.length < 2;
      if (nodes.length < 2) return;

      const box = this.getBoundingClientRect();
      const center = (node) => {
        const rect = node.getBoundingClientRect();
        return { x: rect.left + rect.width / 2 - box.left, y: rect.top + rect.height / 2 - box.top };
      };
      const first = center(nodes[0]);
      const last = center(nodes[nodes.length - 1]);
      const currentNode = this.querySelector('.is-current .kl-timeline__node');
      const current = currentNode ? center(currentNode) : first;
      const horizontal = Math.abs(last.x - first.x) > Math.abs(last.y - first.y);

      this.dataset.axis = horizontal ? 'x' : 'y';
      Object.assign(this.track.style, {
        left: `${first.x}px`,
        top: `${first.y}px`,
        width: horizontal ? `${last.x - first.x}px` : '',
        height: horizontal ? '' : `${last.y - first.y}px`,
      });
      this.fill.style.setProperty('--kl-fill', `${horizontal ? current.x - first.x : current.y - first.y}px`);
    }
  }

  if (!customElements.get('kl-timeline')) {
    customElements.define('kl-timeline', KlTimeline);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klaly-results"] && !Shopify.designMode) return;
  try {
    
  class KlCarouselDots extends HTMLElement {
    connectedCallback() {
      this.rail = document.getElementById(this.dataset.railId);
      if (!this.rail) return;

      this.dots = [...this.querySelectorAll('button')];
      this.items = [...this.rail.children];
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index)));

      this.onScroll = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      };
      this.rail.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      this.update();
      this.setupAutoplay();
    }

    disconnectedCallback() {
      this.rail?.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      this.stopAutoplay();
      this.observer?.disconnect();
      document.removeEventListener('visibilitychange', this.onVisibility);
    }

    // Défilement automatique : uniquement si la section l'active, que la cliente n'a pas
    // demandé à réduire les animations et que le carrousel est à l'écran. Pause au survol
    // et au focus ; arrêt définitif dès qu'elle fait défiler ou choisit un visuel elle-même.
    setupAutoplay() {
      const delay = Number(this.dataset.autoplay);
      if (!(delay > 0) || this.items.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.delay = delay;
      this.inView = false;
      this.paused = false;
      this.stopped = false;

      const stop = () => {
        this.stopped = true;
        this.stopAutoplay();
      };
      ['pointerdown', 'wheel', 'touchstart', 'keydown'].forEach((type) =>
        this.rail.addEventListener(type, stop, { passive: true })
      );
      this.dots.forEach((dot) => dot.addEventListener('click', stop));

      const pause = () => {
        this.paused = true;
        this.stopAutoplay();
      };
      const resume = () => {
        this.paused = false;
        this.startAutoplay();
      };
      this.rail.addEventListener('mouseenter', pause);
      this.rail.addEventListener('mouseleave', resume);
      this.rail.addEventListener('focusin', pause);
      this.rail.addEventListener('focusout', resume);

      this.onVisibility = () => (document.hidden ? this.stopAutoplay() : this.startAutoplay());
      document.addEventListener('visibilitychange', this.onVisibility);

      this.observer = new IntersectionObserver(
        ([entry]) => {
          this.inView = entry.isIntersecting;
          this.inView ? this.startAutoplay() : this.stopAutoplay();
        },
        { threshold: 0.5 }
      );
      this.observer.observe(this.rail);
    }

    startAutoplay() {
      if (this.stopped || this.paused || !this.inView || document.hidden || this.timer) return;
      this.timer = setInterval(() => {
        if (this.hidden) return;
        const current = this.dots.findIndex((dot) => dot.hasAttribute('aria-current'));
        const { scrollLeft, scrollWidth, clientWidth } = this.rail;
        const atEnd = scrollLeft + clientWidth >= scrollWidth - 2;
        this.goTo(atEnd ? 0 : current + 1);
      }, this.delay);
    }

    stopAutoplay() {
      clearInterval(this.timer);
      this.timer = null;
    }

    offsetOf(index) {
      return this.items[index].offsetLeft - this.items[0].offsetLeft;
    }

    goTo(index) {
      if (!this.items[index]) return;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.rail.scrollTo({ left: this.offsetOf(index), behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    update() {
      const { scrollLeft, scrollWidth, clientWidth } = this.rail;
      this.hidden = scrollWidth <= clientWidth + 1;

      let active = 0;
      if (scrollLeft + clientWidth >= scrollWidth - 2) {
        active = this.items.length - 1;
      } else {
        let closest = Infinity;
        this.items.forEach((item, index) => {
          const distance = Math.abs(this.offsetOf(index) - scrollLeft);
          if (distance < closest) {
            closest = distance;
            active = index;
          }
        });
      }

      this.dots.forEach((dot, index) => {
        if (index === active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }
  }

  if (!customElements.get('kl-carousel-dots')) {
    customElements.define('kl-carousel-dots', KlCarouselDots);
  }

  // Défilement continu : le toucher met en pause tant que le doigt reste posé
  // (le survol à la souris est géré en CSS). Les points suivent le visuel arrivé
  // au bord gauche ; un clic sur un point amène ce visuel au bord gauche.
  class KlMarquee extends HTMLElement {
    connectedCallback() {
      const pause = () => this.classList.add('is-paused');
      const play = () => this.classList.remove('is-paused');
      this.addEventListener('pointerdown', pause);
      ['pointerup', 'pointercancel', 'pointerleave'].forEach((type) => this.addEventListener(type, play));

      this.track = this.querySelector('.kl-results__track');
      this.dots = [...this.querySelectorAll('.kl-results__dot')];
      if (!this.track || this.dots.length < 2) return;
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index)));
      this.timer = setInterval(() => this.update(), 250);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    // L'animation fait glisser une série complète : sa progression donne le visuel en cours.
    animation() {
      const animation = this.track.getAnimations?.()[0];
      if (!animation) return null;
      const duration = Number(animation.effect.getComputedTiming().duration);
      return duration > 0 ? { animation, duration } : null;
    }

    update() {
      const current = this.animation();
      if (!current) return;
      const progress = ((Number(current.animation.currentTime) % current.duration) / current.duration) * this.dots.length;
      const active = Math.round(progress) % this.dots.length;
      this.dots.forEach((dot, index) => {
        if (index === active) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    goTo(index) {
      const current = this.animation();
      if (!current) return;
      current.animation.currentTime = (index / this.dots.length) * current.duration;
      this.update();
    }
  }

  if (!customElements.get('kl-marquee')) {
    customElements.define('kl-marquee', KlMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["klaly-video-carousel"] && !Shopify.designMode) return;
  try {
    
  // Carrousel de vidéos verticales : défilement au doigt, flèches et compteur.
  // « Regardez la vidéo » lance la vidéo avec le son et ses contrôles ; une seule vidéo joue à la fois.
  class KlVideoCarousel extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-rail]');
      this.cards = [...this.rail.children];
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.current = this.querySelector('[data-current]');

      this.prev?.addEventListener('click', () => this.goTo(this.index - 1));
      this.next?.addEventListener('click', () => this.goTo(this.index + 1));
      this.onScroll = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      };
      this.rail.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);

      this.querySelectorAll('[data-play]').forEach((button) => {
        button.addEventListener('click', () => this.play(button.closest('.kl-video-card')));
      });
      this.querySelectorAll('video').forEach((video) => {
        video.addEventListener('ended', () => {
          video.closest('.kl-video-card').classList.remove('is-playing');
          video.controls = false;
          video.currentTime = 0;
        });
      });

      this.index = 0;
      this.update();
    }

    disconnectedCallback() {
      this.rail?.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    play(card) {
      const video = card?.querySelector('video');
      if (!video) return;
      this.querySelectorAll('video').forEach((other) => {
        if (other !== video) other.pause();
      });
      card.classList.add('is-playing');
      video.controls = true;
      video.muted = false;
      video.play().catch(() => {
        video.muted = true;
        video.play().catch(() => {});
      });
    }

    offsetOf(index) {
      return this.cards[index].offsetLeft - this.cards[0].offsetLeft;
    }

    goTo(index) {
      if (!this.cards[index]) return;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.rail.scrollTo({ left: this.offsetOf(index), behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    update() {
      const { scrollLeft, scrollWidth, clientWidth } = this.rail;
      let active = 0;
      if (scrollLeft + clientWidth >= scrollWidth - 2) {
        active = this.cards.length - 1;
      } else {
        let closest = Infinity;
        this.cards.forEach((card, index) => {
          const distance = Math.abs(this.offsetOf(index) - scrollLeft);
          if (distance < closest) {
            closest = distance;
            active = index;
          }
        });
      }
      this.index = active;
      if (this.current) this.current.textContent = active + 1;
      if (this.prev) this.prev.disabled = active === 0;
      if (this.next) this.next.disabled = active === this.cards.length - 1;
    }
  }

  if (!customElements.get('kl-video-carousel')) {
    customElements.define('kl-video-carousel', KlVideoCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
